import request from 'utils/request';

import type {
  Collaborators,
  ListCollaboratorsParams,
  AcquireLockParams,
  RemoveLockParams,
  LockAcquisitionResult,
  LockRemovalResult,
} from './types';

const parseCollaboratorsList = (
  dataIn: Collaborators,
  userId: number,
): Collaborators => {
  // filter out null values and current user from response
  const data = { ...dataIn };
  for (const quoteItemId in data) {
    const collaborator = data[quoteItemId];
    if (collaborator === null || collaborator.id === userId) {
      delete data[quoteItemId];
    }
  }
  return data;
};

export const listCollaborators = async ({
  groupId,
  quoteId,
  userId,
}: ListCollaboratorsParams): Promise<Collaborators> => {
  try {
    const response = await request.get<Collaborators>(
      `/quotes/${quoteId}/collaborators`,
      {
        group: groupId,
      },
    );
    return parseCollaboratorsList(response, userId);
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const acquireLock = async ({
  force = false,
  quoteItemId,
  userId,
}: AcquireLockParams): Promise<LockAcquisitionResult> => {
  try {
    const response = await request.post<LockAcquisitionResult>(
      `/quotes/items/${quoteItemId}/lock${force ? '?force=true' : ''}`,
    );
    response.collaborators = parseCollaboratorsList(
      response.collaborators,
      userId,
    );
    return response;
  } catch (error) {
    console.error(error);
    return { acquired: false, collaborators: {} };
  }
};

export const removeLock = async ({
  quoteItemId,
  userId,
}: RemoveLockParams): Promise<LockRemovalResult> => {
  try {
    const response = await request.delete<LockRemovalResult>(
      `/quotes/items/${quoteItemId}/lock`,
    );
    response.collaborators = parseCollaboratorsList(
      response.collaborators,
      userId,
    );
    return response;
  } catch (error) {
    console.error(error);
    return { removed: false, collaborators: {} };
  }
};
